import { css } from "styled-components";

export const MandatePopoverCss = css`
    .mandate-popover {
        .ant-popover-title {
            padding-right: 9px;
        }
        
        .ant-popover-inner-content {
            min-width: max-content;
        }
    }
`;
